
import React from 'react';
import { Invoice } from '@/components/InvoiceList';

interface LineItemsProps {
  invoice: Invoice;
  formatCurrency: (value: number) => string;
}

const LineItems: React.FC<LineItemsProps> = ({ invoice, formatCurrency }) => {
  return (
    <div className="space-y-4 mb-8">
      {invoice.lineItems && invoice.lineItems.map((item, index) => (
        <div key={`item-${index}`} className="flex items-center justify-between p-4 bg-gray-50 rounded-lg">
          <div>
            <div className="font-medium">{item.name}</div>
            {item.description && <div className="text-sm text-gray-600 mt-1">{item.description}</div>}
            {item.isSubscription && (
              <div className="text-sm text-blue-600 mt-1">
                {item.recurringPeriod || invoice.recurringPeriod || 'Monthly subscription'} (Autopay enabled)
              </div>
            )}
          </div>
          <div className="font-bold text-lg">{formatCurrency(item.amount)}</div>
        </div>
      ))}
    </div>
  );
};

export default LineItems;
